export enum ApprovalSettingName {
  SENDER_FROM_EMAIL = 'SENDER_FROM_EMAIL',
  REPLY_TO_EMAIL = 'REPLY_TO_EMAIL',
}
